import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '../hooks/useSession';

/** Route guard — redirects to /unlock when there's no in-memory session. */
export function RequireSession({ children }: { children: ReactNode }) {
  const session = useSession();
  if (session == null) {
    return <Navigate to="/unlock" replace />;
  }
  return <>{children}</>;
}
